import GenericBetFundsInfo from './_generic-bet-funds-info.js'

export default {
  name: 'PayoutInfo',
  values: {
    betInfo: {
      configSet: GenericBetFundsInfo,
      configValues: {
        container: {
          itemSpacing: '0px',
        },
      },
    },
    notAvailableValuel10nKey: '$BET_FUNDS.NOT_AVAILABLE',
  },
  meta: {
    extendable: false,
  },
}
